import {deleteFetcher, postFetcher} from "../api/fetchers";
import UserRole, {roleLabels} from "../../schemas/user/roles";
import {UserAccount} from "../../schemas/user/userAccountSchemas";

export const updateRoles = async (
    user: UserAccount,
    roles: UserRole[],
    showNotification: Function
) => {

    // compare roles to find out which roles were added and which were removed
    const rolesToAdd = roles.filter((role) => !user.roles.includes(role));
    const rolesToRemove = user.roles.filter((role) => !roles.includes(role));

    rolesToAdd.forEach((role) => {
        postFetcher(`/users/${user?.id}/roles`, {role})
            .then(() => showNotification(`Role ${roleLabels[role] || role} byla přidána`, "success"))
            .catch(() => showNotification(`Nepodařilo se přidat roli ${roleLabels[role] || role}`, "error"));
    });

    rolesToRemove.forEach((role) => {
        deleteFetcher(`/users/${user?.id}/roles/${role}`)
            .then(() => showNotification(`Role ${roleLabels[role] || role} byla odebrána`, "success"))
            .catch(() => showNotification(`Nepodařilo se odebrat roli ${roleLabels[role] || role}`, "error"));
    });

    return rolesToAdd.length === 0 && rolesToRemove.length === 0;
}